// Export inclusion and data types based on legacy implementation

export enum EXPORT_INCLUSION_TYPES {
  FILTERS = "FILTERS",
  ALL = "ALL",
  NONE = "NONE",
  SELECTED = "SELECTED",
}

export enum EXPORT_DATA_TYPES {
  INSTALL = "Product Installs",
  INTENT = "Intent Activity",
  CONTRACTS = "Contracts",
  FAI = "Functional Area Intelligence data",
  SPEND = "Spend data",
  MENTIONS = "Mentions",
  GENERATIVE_AI = "Gen AI Navigator",
  MENTION_TIME_SERIES = "Mention Time Series data",
  RELATIVE_SPEND = "Relative Spend data",
  TIME_SERIES = "Time Series data",
}

export enum EXPORT_RELATED_FILTERS {
  PRODUCTS = "Product",
  INTENT = "Intent",
  CONTRACTS = "Contracts",
}
